/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * GREATER_THAN_OR_EQUAL operator looks for values that are greater than or equal to the given value.
 */
export interface GreaterThanOrEqualRevision {
    /** The value to compare against. */
    value: number;
}
